export const RightArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.74609 11.9996C3.74609 11.5854 4.08188 11.2496 4.49609 11.2496L18.6852 11.2496L13.2991 5.86356C13.0062 5.57067 13.0062 5.0958 13.2991 4.8029C13.592 4.51001 14.0669 4.51001 14.3598 4.8029L21.0089 11.452C21.0148 11.4576 21.0207 11.4632 21.0265 11.469C21.1734 11.6159 21.2466 11.8087 21.2461 12.0012C21.2458 12.1927 21.1726 12.3841 21.0265 12.5302C21.0207 12.536 21.0148 12.5417 21.0089 12.5472L14.3598 19.1963C14.0669 19.4892 13.592 19.4892 13.2991 19.1963C13.0062 18.9035 13.0062 18.4286 13.2991 18.1357L18.6852 12.7496L4.49609 12.7496C4.08188 12.7496 3.74609 12.4138 3.74609 11.9996Z"
        fill="black"
      />
    </svg>
  );
};
